import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { MassivePackingApiAdapter } from '../adapters';
import { MassivePackingService } from '../services';
import type { MassivePackingData } from '../models';

// 🎯 Hook principal para la pantalla de Packing Masivo
export const useMassivePacking = (preparationId: number) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const apiAdapter = useMemo(
    () => new MassivePackingApiAdapter(httpClient),
    [httpClient],
  );
  const service = useMemo(
    () => new MassivePackingService(apiAdapter),
    [apiAdapter],
  );

  const {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery<MassivePackingData>({
    queryKey: ['massivePacking', preparationId],
    queryFn: () => service.loadMassivePackingData(preparationId),
    enabled: preparationId > 0,
    staleTime: 2 * 60 * 1000, // 2 minutos
  });

  const result = useMemo(
    () => ({
      preparation: data?.preparation ?? null,
      orders: data?.orders ?? [],
      groups: data?.groups ?? [],
    }),
    [data],
  );

  return {
    ...result,
    isLoading,
    isFetching,
    error: (error as Error | null)?.message ?? null,
    refetch,
    service,
  };
};

